import { render, staticRenderFns } from "./GOODS_two_column_fullbleed.vue?vue&type=template&id=35567282&"
import script from "./GOODS_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./GOODS_two_column_fullbleed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports